export const GET_INVENTORY_SERVICES = 'GET_INVENTORY_SERVICES';
export const GET_INVENTORY_SERVICES_SUCCESS = 'GET_INVENTORY_SERVICES_SUCCESS';
export const GET_INVENTORY_SERVICES_FAILED = 'GET_INVENTORY_SERVICES_FAILED';

export const ADD_INVENTORY_SERVICES = 'ADD_INVENTORY_SERVICES';
export const ADD_INVENTORY_SERVICES_SUCCESS = 'ADD_INVENTORY_SERVICES_SUCCESS';
export const ADD_INVENTORY_SERVICES_FAILED = 'ADD_INVENTORY_SERVICES_FAILED';

export const EDIT_INVENTORY_SERVICES = 'EDIT_INVENTORY_SERVICES';
export const EDIT_INVENTORY_SERVICES_SUCCESS = 'EDIT_INVENTORY_SERVICES_SUCCESS';
export const EDIT_INVENTORY_SERVICES_FAILED = 'EDIT_INVENTORY_SERVICES_FAILED';

export const DELETE_INVENTORY_SERVICES = 'DELETE_INVENTORY_SERVICES';
export const DELETE_INVENTORY_SERVICES_SUCCESS = 'DELETE_INVENTORY_SERVICES_SUCCESS';
export const DELETE_INVENTORY_SERVICES_FAILED = 'DELETE_INVENTORY_SERVICES_FAILED'; 